export default function DeleteIcon() {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.68753 7.3125V11.8125M5.31253 7.3125V11.8125M13.1873 3.9375L0.812256 3.9375M12.0625 3.9375V14.625C12.0625 14.7742 12.0033 14.9173 11.8978 15.0227C11.7923 15.1282 11.6492 15.1875 11.5 15.1875H2.50003C2.35085 15.1875 2.20777 15.1282 2.10228 15.0227C1.99679 14.9173 1.93753 14.7742 1.93753 14.625V3.9375M9.81253 3.9375V2.8125C9.81253 2.51413 9.694 2.22798 9.48303 2.017C9.27205 1.80603 8.9859 1.6875 8.68753 1.6875H5.31253C5.01416 1.6875 4.72801 1.80603 4.51704 2.017C4.30606 2.22798 4.18753 2.51413 4.18753 2.8125V3.9375"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
